import React from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { EmptyState } from './ui/States';

/** D104.27: the RFQ inbox lives at /rfq; /inbox (what people type) lands there, query string kept. */
export const InboxRedirect: React.FC = () => {
  const { search } = useLocation();
  return <Navigate to={{ pathname: '/rfq', search }} replace />;
};

/** Any URL no route claims. Without it the router renders nothing — a blank white page. */
export const NotFoundPage: React.FC = () => (
  <div className="p-8">
    <EmptyState title="Page not found" detail="This address does not match a page in the app." />
    <Link to="/rfq" className="mt-3 inline-block text-sm font-semibold text-primary-500 hover:underline">
      Go to the inbox
    </Link>
  </div>
);
